document.addEventListener('DOMContentLoaded', function () {
  var carousels = document.querySelectorAll('.video-carousel-block');
  // console.log("🔄 Found video carousel blocks:", carousels.length);

  carousels.forEach(function (carousel, index) {
    // console.log(`🎯 Initializing Swiper for video carousel block #${index + 1}`);

    var swiper = new Swiper(carousel, {
      slidesPerView: 'auto',
      spaceBetween: 5,
       
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      loop: true,
      navigation: {
        nextEl: carousel.querySelector('.video-block-button-next'),
        prevEl: carousel.querySelector('.video-block-button-prev'),
      },
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 'auto',
        },
        1024: {
          slidesPerView: 'auto',
        }
      },
      on: {
        init: function () {
          // console.log("✅ Swiper initialized for video carousel block");
          playActiveVideo(this);
        },
        slideChange: function () {
          // console.log("➡️ Swiper slide changed to:", this.activeIndex);
          playActiveVideo(this);
        }
      }
    });

    function playActiveVideo(swiper) {
      var slides = swiper.slides;
      // console.log("⏹ Pausing all videos");
      slides.forEach(function (slide, idx) {
        var video = slide.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });

      var activeSlide = slides[swiper.activeIndex];
      var activeVideo = activeSlide.querySelector('video');

      if (activeVideo) {
        // console.log("▶️ Playing active video on slide:", swiper.activeIndex);
        activeVideo.play();
        activeVideo.onended = function () {
          // console.log("🔁 Video ended, going to next slide...");
          if (swiper.activeIndex < slides.length - 1) {
            swiper.slideNext();
          } else {
            swiper.slideTo(0);
          }
        };
      }
    }

    // Fullscreen modal for mobile
    var modal = document.querySelector('.video-carousel-block-modal');
    var modalVideo = modal ? modal.querySelector('video') : null;
    var modalClose = modal ? modal.querySelector('.video-carousel-block-modal__close') : null;
    var modalProduct = modal ? modal.querySelector('.video-carousel-block-modal__product') : null;
    var modalToggleProduct = modal ? modal.querySelector('.video-carousel-block-modal__toggle-product-btn') : null;

    // console.log("📦 Modal initialized:", modal);

    function isMobile() {
      const isMob = window.innerWidth < 768;
      // console.log("📱 isMobile:", isMob);
      return isMob;
    }

    carousel.querySelectorAll('.video-carousel-block__video').forEach(function (videoEl, vidIndex) {
      // console.log(`📹 Binding click to video #${vidIndex}`);

      videoEl.addEventListener('click', function (e) {
        // console.log("🎬 Video clicked");

        if (!isMobile()) {
          // console.log("🖥️ Desktop — scrolling to product form");
          e.preventDefault();
          
          // Find the product form
          const productForm = document.querySelector('product-form.product-form[data-hide-errors="false"]');
          if (productForm) {
            // Scroll to the product form with smooth animation
            productForm.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center' 
            });
            
            // Add a subtle highlight effect
           
          } else {
            // console.warn("⚠️ Product form not found");
          }
          return;
        }
 
        e.preventDefault();
        var slide = videoEl.closest('.swiper-slide');
        var videoSrc = videoEl.getAttribute('src');
        var poster = videoEl.getAttribute('poster');
        var productInfo = slide.querySelector('.video-carousel-block__product-info').innerHTML;

        // Store all slides and current index for modal navigation
        var allSlides = Array.from(carousel.querySelectorAll('.swiper-slide'));
        modal._allSlides = allSlides;
        modal._currentIndex = allSlides.indexOf(slide);

        // console.log("📼 Video src:", videoSrc);
        // console.log("🖼️ Poster:", poster);

        if (modal && modalVideo && modalProduct) {
          modalVideo.src = videoSrc;
          modalVideo.poster = poster;
          modalProduct.innerHTML = productInfo;
          modal.classList.add('active');
          document.body.classList.add('modal-open');
          modalVideo.currentTime = 0;
          modalVideo.muted = false;
          modalVideo.play();
          const muteToggle = modalVideo.closest('.video-carousel-block-modal__video-wrapper').querySelector('.mute-toggle-block');
          if (muteToggle) {
            const mutedIcon = muteToggle.querySelector('.icon-muted-block');
            const unmutedIcon = muteToggle.querySelector('.icon-unmuted-block');

            if (mutedIcon && unmutedIcon) {
              mutedIcon.style.display = 'none';
              unmutedIcon.style.display = 'inline-flex';
            }
          } 

          // Move #cart-toast to the end of <body> when modal opens
          var cartToast = document.getElementById('cart-toast');
          if (cartToast && cartToast.parentNode !== document.body) {
            cartToast._originalParent = cartToast.parentNode;
            document.body.appendChild(cartToast);
          }

          // Add click handler for "View Cart" button in cart-toast when modal is open
          var viewCartButton = cartToast ? cartToast.querySelector('#view-cart-button') : null;
          if (viewCartButton) {
            viewCartButton.addEventListener('click', function(e) {
              e.preventDefault();
              // Close the video modal
              closeModal();
              // Open the cart drawer
              if (window.customElements && customElements.get('mini-cart')) {
                const miniCart = document.querySelector('mini-cart');
                if (miniCart && typeof miniCart.open === 'function') {
                  miniCart.open();
                }
              }
            });
          }

          // Mute all desktop carousel videos when modal opens
          carousel.querySelectorAll('.video-carousel-block__video').forEach(function (video) {
            video.muted = true;
            // console.log("✅ Modal opened muted");

            // Update mute icon states for desktop videos
            const muteToggle = video.closest('.video-carousel-block__video-wrapper').querySelector('.mute-toggle-block');
            if (muteToggle) {
              const mutedIcon = muteToggle.querySelector('.icon-muted-block');
              const unmutedIcon = muteToggle.querySelector('.icon-unmuted-block');

              if (mutedIcon && unmutedIcon) {
                mutedIcon.style.display = 'inline-flex';
                unmutedIcon.style.display = 'none';
              }
            }
          });

          // console.log("✅ Modal opened with video");
        } else {
          // console.warn("⚠️ Modal or parts missing");
        }
      });
    });

    // --- Swipe up/down to navigate videos in modal (mobile only) ---
    if (modal) {
      let touchStartY = null;
      let touchEndY = null;
      const SWIPE_THRESHOLD = 50; // px

      function handleTouchStart(e) {
        if (!isMobile() || !modal.classList.contains('active')) return;
        touchStartY = e.touches[0].clientY;
      }
      function handleTouchMove(e) {
        if (!isMobile() || !modal.classList.contains('active')) return;
        touchEndY = e.touches[0].clientY;
      }
      function handleTouchEnd(e) {
        if (!isMobile() || !modal.classList.contains('active')) return;
        if (touchStartY === null || touchEndY === null) return;
        const deltaY = touchStartY - touchEndY;
        if (Math.abs(deltaY) > SWIPE_THRESHOLD) {
          if (deltaY > 0) {
            // Swipe up: next video
            showModalVideoByIndex(modal._currentIndex + 1);
          } else {
            // Swipe down: previous video
            showModalVideoByIndex(modal._currentIndex - 1);
          }
        }
        touchStartY = null;
        touchEndY = null;
      }
     function showModalVideoByIndex(idx) {
      const slides = modal._allSlides || [];
      if (!slides.length || idx < 0 || idx >= slides.length) return;

      const slide = slides[idx];
      const videoEl = slide.querySelector('video');
      const productInfo = slide.querySelector('.video-carousel-block__product-info').innerHTML;

      if (videoEl && modalVideo && modalProduct) {
        const poster = videoEl.getAttribute('poster');
        modalVideo.pause();
        modalVideo.src = videoEl.getAttribute('src');
        modalVideo.poster = poster;
        modalProduct.innerHTML = productInfo;
        modal._currentIndex = idx;

        // ✅ Set background-image using the poster
        modalVideo.style.backgroundImage = `url('${poster}')`;
        modalVideo.style.backgroundSize = 'cover';
        modalVideo.style.backgroundColor = 'black';

        modalVideo.load();

        modalVideo.onloadeddata = function () {
          modalVideo.currentTime = 0;
          modalVideo.play().catch((e) => console.warn("🎥 Modal video play error:", e));
        };
      }
    }

      modal.addEventListener('touchstart', handleTouchStart);
      modal.addEventListener('touchmove', handleTouchMove);
      modal.addEventListener('touchend', handleTouchEnd);
      // Expose for debugging
      modal._showModalVideoByIndex = showModalVideoByIndex;
    }

    if (modal && modalClose) {
      modalClose.addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          // console.log("🖱️ Clicked outside modal content, closing...");
          closeModal();
        }
      });
    }

    function closeModal() {
      if (modal && modalVideo) {
        // console.log("❎ Closing modal");
        modal.classList.remove('active');
        document.body.classList.remove('modal-open');
        modalVideo.pause();
        modalVideo.currentTime = 0;
        modalVideo.src = '';

        // Restore #cart-toast to its original position
        var cartToast = document.getElementById('cart-toast');
        if (cartToast && cartToast._originalParent) {
          cartToast._originalParent.appendChild(cartToast);
          cartToast._originalParent = null;
        }
      }
    }

    // Product toggle functionality
    if (modalToggleProduct && modalProduct) {
      modalToggleProduct.addEventListener('click', function () {
        modalProduct.classList.toggle('hidden');
        modalToggleProduct.classList.toggle('rotated');

        // Update aria-label for accessibility
        const isHidden = modalProduct.classList.contains('hidden');
        modalToggleProduct.setAttribute('aria-label',
          isHidden ? 'Show Product Details' : 'Hide Product Details'
        );
      });
    }
  }); // End of carousels.forEach

  // Restore global mute toggle functionality
  document.querySelectorAll('.video-block-mute .mute-toggle-block').forEach(button => {
    const video = button.closest('.video-block-mute').querySelector('video');
    const mutedIcon = button.querySelector('.icon-muted-block');
    const unmutedIcon = button.querySelector('.icon-unmuted-block');

    button.addEventListener('click', () => {
      video.muted = !video.muted;

      if (video.muted) {
        mutedIcon.style.display = 'inline-flex';
        unmutedIcon.style.display = 'none';
      } else {
        mutedIcon.style.display = 'none';
        unmutedIcon.style.display = 'inline-flex';
      }
    });
  });
});